import { render, staticRenderFns } from "./CustomFieldSchemas.vue?vue&type=template&id=6a08c33e"
import script from "./CustomFieldSchemas.vue?vue&type=script&lang=js"
export * from "./CustomFieldSchemas.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldSchemas.vue?vue&type=style&index=0&id=6a08c33e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports